/* istanbul ignore file */

export const MEASUREMENT_UNIT_MMOL_L = 'mmol/l';
export type MEASUREMENT_UNIT_MMOL_L = typeof MEASUREMENT_UNIT_MMOL_L;

export const MEASUREMENT_UNIT_MG_DL = 'mg/dl';
export type MEASUREMENT_UNIT_MG_DL = typeof MEASUREMENT_UNIT_MG_DL;

export type MEASUREMENT_UNIT = MEASUREMENT_UNIT_MMOL_L | MEASUREMENT_UNIT_MG_DL;
